import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import LookBookQuoteContainer from "./../../components/lookBookQuoteContainer";
import CollectionHero from "./../../components/collectionHero";
import LookBookCenteredImage from "./../../components/lookBookCenteredImage";
import LookBookFullWidthImage from "./../../components/lookBookFullWidthImage";
import LookBookOnePhotoAndColor from "./../../components/lookBookOnePhotoAndColor";
import LookBookSideBySideImages from "./../../components/lookBookSideBySideImages";
import StoryFooter from "./../../components/storyFooter";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import BackButton from './../../alpineComponents/backButton';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";
import FlodeskForm from './../../components/flodeskForm';

//findingTimePdf

export default class FindingTime extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>{'Free Chapter - How to set goals that work Kat Medina'}</title>
          <meta name="description" content="The Joys of Jet Lag, Chapter 11 on Goal Setting" />
        </Helmet>
        <BannerFadeIn>
          <div className="background-image-fill" style={{backgroundImage:`url(/images/blog-joy.jpg)`}}>
            <div className="brain-fucks-hero extra-large-padding centered-text" style={{backgroundColor:'rgba(0,0,0,.5)'}}>
            </div>
          </div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="small-max-width-container lip">
            <div className="primary-background centered-text mailchimp-form-container">
              <div className="small-max-width-container">
                <FlodeskForm segment="Goal Setting" />
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/goalSetting/index.js